import axios from 'axios'

const baseURL = process.env.BASE_URL
const apiURL = process.env.ROOT_API

export default {

  getSubject(id) {
    return axios
      .get(apiURL + '/subjects/' + id)
  },

  createSubject(linkedID, linkedName, descriptionTrello) {
    return axios
      .post(apiURL + '/subjects', {
        title: linkedName,
        trelloCardId: linkedID,
        resume: descriptionTrello
      })
  },

  /**
   * Cette méthode gère la persistance des informations d'un sujet
   *
   * @param subjectID
   * @param datas
   */
  persistSection(subjectID, datas) {
    // préparation des données
    let params = {}
    for (let data in datas) {
      let elem = datas[data]
      let elemName = data
      // // on ne persiste pas ici les intervenant car c'est fait depuis le composant dédié
      // // et le format de donné disponible ici n'est pas adapté
      if (elemName !== 'intervenants') {
        // la donnée d'un élément est soit un string / null / Date
        if (elem.datas === null || typeof elem.datas === 'string' || elem.datas instanceof Date) {
          params[elemName] = elem.datas
        } else {
          // soit un objet, dans ce cas c'est qu'il s'agit d'une liaison, on adapte la donnée pour l'API
          if (elem.datas.id !== null) {
            params[elemName] = '/api/' + elemName + 's/' + elem.datas.id
          }
        }
      }
      // on ajoute systématiquement la date de dernière modification
      let now = new Date()
      params['lastModificationTime'] = now.toISOString().slice(0, 19).replace('T', ' ');
    }
    return axios
      .put(apiURL + '/subjects/' + subjectID, params)
      .then(response => {
        return response.data
      })
  },

  /**
   * retourne la liste des entités d'un label (format, rubrique..), sur le modèle suivant :
   * {
   *   id: '2',
   *   name: "grand éclairage",
   *   ...
   * }
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  getAvailableLabel(labelName) {
    return axios.get(apiURL + '/' + labelName)
      .then(response => {
        // TODO une manière un peu borderline de gérer le json-ld/hydra...
        for (let data in response.data) {
          if (data === "hydra:member") {
            return response.data[data]
          }
        }
      })
  },

  getIntervenant(id) {
    return axios.get(baseURL + id)
      .then(response => {
        return response.data
      })
  },

  addIntervenant(subjectId) {
    return axios
      .post(apiURL + '/intervenants', {subject: '/api/subjects/' + subjectId})
      .then(response => {
        return '/api/intervenants/' + response.data.id
      })
  },

  persistIntervenant(id, datas) {
    datas.aInviter = datas.aInviter.toString()
    return axios
      .put(baseURL + id, datas)
      .then(response => {
        return response.data
      })
  },

  deleteIntervenant(id) {
    return axios
      .delete(baseURL + id)
      .then(response => {
        return response.data
      })
  },

  addContact() {
    return axios
      .post(apiURL + '/contacts', {})
      .then(response => {
        return '/api/contacts/' + response.data.id
      })
  },

  getContact(id) {
    return axios.get(baseURL + id)
      .then(response => {
        return response.data
      })
  },

  persistContact(id, contact) {
    return axios.put(baseURL + id, contact)
      .then(response => {
        return response.data
      })
  },

  getMedia(id) {
    return axios.get(baseURL + id)
      .then(response => {
        return response.data
      })
  },

  postMedia(formData) {
    return axios.post(apiURL + '/media_objects',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(response => {
      return response.data
    })
      .catch(error => {
        console.log('upload error', error)
        return error
      })
  }

}


// WEBPACK FOOTER //
// ./src/api/bdd.js